"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("@rainbow-modules/icons");

var _styled = require("./styled");
/* eslint-disable-next-line import/no-unresolved */


var iconMap = {
  error: _icons.Error,
  success: _icons.Done,
  warning: _icons.Warning
};

var Message = function Message(props) {
  var isVisible = props.isVisible,
      message = props.message,
      variant = props.variant,
      timeout = props.timeout,
      onHideMessage = props.onHideMessage;
  var timeoutId = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (typeof timeout === 'number') {
      timeoutId.current = setTimeout(function () {
        return onHideMessage();
      }, timeout);
    }
  }, [timeout, onHideMessage]);

  var hideMessage = function hideMessage() {
    onHideMessage();

    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_styled.Container, {
    isVisible: isVisible,
    variant: variant
  }, /*#__PURE__*/_react["default"].createElement(_styled.MessageContainer, null, /*#__PURE__*/_react["default"].createElement(_styled.MessageIcon, {
    variant: variant,
    as: iconMap[variant]
  }), /*#__PURE__*/_react["default"].createElement(_styled.MessageText, {
    variant: variant
  }, message), /*#__PURE__*/_react["default"].createElement(_styled.ButtonIcon, {
    variant: variant,
    size: "medium",
    icon: /*#__PURE__*/_react["default"].createElement(_icons.Close, null),
    onClick: hideMessage
  })));
};

Message.propTypes = {
  isVisible: _propTypes["default"].bool.isRequired,
  message: _propTypes["default"].node,
  variant: _propTypes["default"].oneOf(['success', 'warning', 'error']),
  timeout: _propTypes["default"].number,
  onHideMessage: _propTypes["default"].func
};
Message.defaultProps = {
  message: undefined,
  variant: 'error',
  timeout: undefined,
  onHideMessage: function onHideMessage() {}
};
var _default = Message;
exports["default"] = _default;